@if (isLoadingData()) {
  <div class="movie-credits-wrap movie-detail-section movie-credits-skeleton">
    <ush-movie-detail-skeleton width="8rem" height="1.5rem" />
    <div class="movie-credits-skeleton__rows">
      @for (row of [1, 2, 3, 4]; track row) {
        <div class="movie-credits-skeleton__row">
          <ush-movie-detail-skeleton width="8rem" height="1rem" />
          <ush-movie-detail-skeleton width="100%" height="1rem" />
        </div>
      }
    </div>
  </div>
} @else if (hasRenderableCredits) {
  <div class="movie-credits-wrap movie-detail-section" [class.canCollapse]="canCollapse" [class.collapsed]="collapsed">
    <div class="header-msg title" (click)="toggleCollapse()" data-translate="movie.menu.credits">
      {{ creditsTitle }}
    </div>
    <div class="movie-credits credits-content">
      <!-- Standar Crew-->
      <ng-container *ngIf="!customCrew">
        <ul class="info-list">
          <ng-container *ngFor="let credit of crewListing">
            <li *ngIf="credit" [ngClass]="credit.roleClass + '-list'">
              <div class="subtitle" [attr.data-translate]="credit.role">
                <div class="subtitle-header">{{ credit.translatedRole }}<span class="semicolon">:</span></div>
              </div>
              <div class="text">
                <span
                  *ngFor="let star of credit.starList"
                  class="crew {{ star.customClass }}"
                  [pTooltip]="star?.episodestooltip"
                  tooltipPosition="top"
                >
                  <a *ngIf="star.urlRedirect" [routerLink]="star.urlRedirect">{{ star.name }}</a>
                  <ng-container *ngIf="!star.urlRedirect">{{ star.name }}</ng-container>
                  <span class="comma">, </span>
                </span>
              </div>
            </li>
          </ng-container>
          <ng-container *ngIf="producingCompanies">
            <li class="production-companies">
              <div class="subtitle">
                <span data-translate="crew.role.production-company">{{ productionCompanyTitle }}</span>
                <span class="semicolon">:</span>
              </div>
              <div class="text">{{ producingCompanies }}</div>
            </li>
          </ng-container>
        </ul>
      </ng-container>
      <!-- Custom Crew-->
      <ng-container *ngIf="customCrew">
        <ul class="info-list custom-crew-members">
          <li class="custom-crew-item-list" *ngFor="let credit of customCrew" [attr.data-key]="credit[1] | kebabCase">
            <div
              class="subtitle"
              [attr.data-translate]="'custom.movie.role.' + (credit[1] | kebabCase)"
              [attr.data-notranslate]="true"
            >
              <span>{{ credit[1] }}</span>
              <span class="semicolon">:</span>
            </div>
            <div class="text">{{ credit[2] }}</div>
          </li>
          <ng-container *ngIf="producingCompanies">
            <li class="production-companies">
              <div class="subtitle" data-translate="crew.role.production-company">
                <span>{{ productionCompanyTitle }}</span>
                <span class="semicolon">:</span>
              </div>
              <div class="text">{{ producingCompanies }}</div>
            </li>
          </ng-container>
        </ul>
      </ng-container>
    </div>
  </div>
}
